requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xAnnouncementBars', (barData) => ({
      init() {
        this.$el.innerHTML = this.processContent(barData);
      },
      processContent(bar) {
        let content = bar.settings.content;
        if (content.includes('{count_down}')) {
          content = content.replace(/{count_down}/gi, '<span class="x-countdown-' + bar.id + '" bar-countdown"></span>');
          let parentEl = this.$el;
          Alpine.store('xHelper').countdown(bar.settings, function(canShow, seconds, minutes, hours, days) {
            const countdownElements = parentEl.getElementsByClassName('x-countdown-' + bar.id);

            if (!canShow) {
              for (let i = 0;i < countdownElements.length;i++) {
                countdownElements[i].innerHTML = '';
                countdownElements[i].classList.remove("inline-block", "width-countdown");
              }

              return;
            }

            days = days > 0 ? days + "D&nbsp;&nbsp;" : "";
            hours = hours == 0 && days.length == 0 ? "" : hours + " : ";

            for (let i = 0;i < countdownElements.length;i++) {
              countdownElements[i].innerHTML = days + hours + minutes + " : " + seconds;
              countdownElements[i].classList.add("inline-block", "width-countdown");
            }
          });
        }

        return content;
      }
    }));
  });
});
